export default __webpack_public_path__ + "static/media/BizThree.6b137b80.png";